import React, { useState, useEffect } from "react";
import { CardContent, CardHeader, Button, TextField, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch } from "react-redux";
import { addThemes } from "../../Redux/Action";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { setModal } from "../../../../Common/App";
import {DialogCard, Loader} from "../../../../../Components";
import { JsonThemeEditor } from "../../../../../Components/Elements/JsonThemeEditor";

export const CloneThemeModal = ({ theme, onClose }) => {

    const dispatch = useDispatch();
    const [data, setData] = useState({
        name: "",
        type: "LIGHT",
        properties: {}
    });
    const [errors, setErrors] = useState({});
    const [, setMessage] = useState("");
    const [, setStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (theme) {
            setData({
                name: `${theme.name} (Copy)`,
                type: theme.type || "LIGHT",
                properties: theme.properties || {}
            });
        }
    }, [theme]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({
            ...prev,
            [name]: value
        }));
        setErrors(prev => ({
            ...prev,
            [name]: ""
        }));
    };

    const handleSubmit = async () => {
        setIsLoading(true);
        await addThemes({ dispatch, data }).then((res) => {
            if (res.success) {
                dispatch(setModal({ component: null, open: false }));
                if (onClose) onClose();
            }
            setIsLoading(false);
            setErrors(res.errors);
            setMessage(res.message);
            setStatus(res.status);
        });
    };

    return (
        <DialogCard>
            <CardHeader
                title="Clone Theme"
                avatar={<Loader isLoading={isLoading} type={"linear"} />}
            />
            <CardContent sx={{ p: 2, pt: 2 }}>
                <DialogContentText sx={{ mb: 2 }}>
                    Create a copy of "{theme?.name}" theme. You can modify the name and properties below.
                </DialogContentText>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Theme Name"
                            name="name"
                            value={data.name}
                            onChange={handleChange}
                            error={!!errors.name}
                            helperText={errors.name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel>Theme Type</InputLabel>
                            <Select
                                name="type"
                                value={data.type}
                                onChange={handleChange}
                                error={!!errors.type}
                                label="Theme Type"
                            >
                                <MenuItem value="LIGHT">Light</MenuItem>
                                <MenuItem value="DARK">Dark</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <JsonThemeEditor
                            value={data.properties}
                            name="properties"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <DialogActions sx={{ mb: 2, mr: 2 }}>
                <Button onClick={() => dispatch(setModal({ component: null, open: false }))}>
                    Cancel
                </Button>
                <Button disabled={isLoading} variant="contained" color="primary" onClick={handleSubmit}>
                    Clone Theme
                </Button>
            </DialogActions>
        </DialogCard>
    );
};
